import React, { useState } from "react";

import { MenuContainer } from "../styled/setting";

import Preview from "./menuBoard/preview";
import Products from "./menuBoard/products";
import Details from "./menuBoard/details";
import TabMenu from "./menuBoard/tabMenu";
import Address from "./menuBoard/addr";

const MenuBoard = ({ menuGroups, info, setActive, clickImages, company, selectCompany }) => {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <MenuContainer>
      <div className="preview">
        <Preview company={company} />
        <TabMenu activeTab={activeTab} setActiveTab={setActiveTab} />
        <div className="slideWrapper">
          <div
            className={`slideContent ${!activeTab ? "active" : "inactive"}`}
            style={{ transform: `translateX(${activeTab * -100}%)` }}>
            <Address company={company} />
            <Products menuGroups={menuGroups} />
          </div>
          <div className="slideContent"></div>
          <div
            className={`slideContent ${activeTab ? "active" : "inactive"}`}
            style={{ transform: `translateX(${activeTab * -100}%)` }}>
            <Details
              info={info}
              clickImages={clickImages}
              company={company}
              selectCompany={selectCompany}
            />
          </div>
        </div>
      </div>
      <div className="actions">
        <button onClick={() => setActive("company")}>매장 정보 수정하기</button>
        <button onClick={() => setActive("menuGroup")}>메뉴 관리하기</button>
      </div>
    </MenuContainer>
  );
};

export default MenuBoard;
